<div class="step-container">
    <h1 class="text-tertiary-900">Step One</h1>

    <h2 class="text-tertiary-900">Select Action</h2>

    <img
        src="assets/svg/cevo-go-select-action.svg"
        alt="Check list"
        class="hero-image"
    />

    <p>
        New License, new location, new frequency or mobile only? Choose up to
        five certified frequencies or frequency pairs.
    </p>

    <p>Visit Cevo online to handle more complex requirements.</p>
</div>
